import getAvailablePackagesStatus from './available-packages-status';
import getEcommercePackagesStatus from './ecommerce-packages-status';

export default {
  getAvailablePackagesStatus,
  getEcommercePackagesStatus,
};
